import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import CryptoJS from 'crypto-js';
import './login.css';
const Login = () => {
	const emailRef = useRef(null);
	const passwordRef = useRef(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false); // 新增loading状态
	const navigate = useNavigate();
	const handleSubmit = async (event) => {
		event.preventDefault();
		if (loading) return; // 防止重复提交
		setLoading(true);
		try {
			const encryptedPassword = CryptoJS.MD5(passwordRef.current.value).toString();
			const formData = new FormData();
			let email = emailRef.current.value.trim();
			formData.append('loginid', email);
			formData.append('password', encryptedPassword);
			formData.append('action', 'login');
			await axios.post(process.env.REACT_APP_API_URL+'/webgazer/login.php', formData).then((response) => {
				console.log('Success:', response);
				if (response.data[0].status === 'success') {
					sessionStorage.setItem('username', email);
					sessionStorage.setItem('uid', response.data[0].uid);
					// 登录成功，跳转页面
					navigate('/home');
				} else {
					setError('Invalid email or password'); 
					setTimeout(() => { setError(''); }, 3000);
				}
			});
		} catch (err) {
			console.error('Login error:', err);
			setError('Invalid email or password'); 
			setTimeout(() => { setError(''); }, 3000);
		} finally {
			setLoading(false); // 无论成功失败都允许再次提交
		}
	};
	useEffect(() => {
        const uid = sessionStorage.getItem('uid');
        if (uid) {
			navigate('/home');
        }
    }, []);
	return (
		<div className="login-container">
			<h2>Login</h2>
			<form onSubmit={handleSubmit}>
				<div>
					<label>Email:</label>
					<input
						type="email"
						ref={emailRef}
						required
					/>
				</div>
				<div>
					<label>Password:</label>
					<input
						type="password"
						ref={passwordRef}
						required
					/>
				</div>
				<button id="loginButton" type="submit" disabled={loading}>{loading ? '登录中...' : 'Login'}</button>
				{/* <div className="error-popup">Invalid email or password</div> */}
				{error && <div className="error-popup">{error}</div>}
			</form>
		</div>
	);
}

export default Login;
